import { Component } from '@angular/core';
import { FormLoading } from '../../forms/base-form/base-form.component';
import { BaseModalComponent } from '../base-modal/base-modal.component';

@Component({
  selector: 'app-chart-settings-modal',
  templateUrl: './chart-settings-modal.component.html',
  styleUrls: ['./chart-settings-modal.component.scss'],
})
export class ChartSettingsModalComponent extends BaseModalComponent {
  public handleSubmit({ values, formLoading }: { values: any; formLoading: FormLoading }) {
    try {
      this.startLoading();
      formLoading.start();

      // TODO: add logic

      formLoading.stop();
      this.stopLoading();
      this.close(values);
    } catch (err) {
      formLoading.stop();
      this.stopLoading();
    }
  }
}
